import { render, staticRenderFns } from "./EditDomainsPrefix.domains.vue?vue&type=template&id=ea652754&scoped=true&lang=html&"
import script from "./EditDomainsPrefix.domains.vue?vue&type=script&lang=js&"
export * from "./EditDomainsPrefix.domains.vue?vue&type=script&lang=js&"
import style0 from "./EditDomainsPrefix.domains.vue?vue&type=style&index=0&id=ea652754&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea652754",
  null
  
)

export default component.exports